import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SubSink } from 'subsink';
import { TranslateService } from 'src/app/core/translate';
import { CallRecordModuleService } from '../../service/call-record-module.service';

@Component({
    selector: 'app-sms-call-record',
    templateUrl: './sms-call-record.component.html',
    styleUrls: ['./sms-call-record.component.scss'],
})
export class SmsCallRecordComponent implements OnInit, OnDestroy {
    subs = new SubSink();
    smsCallRecordDetails: any;
    filteredRecipients: any[];
    searchInput = new FormControl('');
    isRetrying = false;
    showLoader = false;
    messageSplit: any;
    retrySuccess = false;
    retryError = false;
    originalDeliveryStatus: boolean;

    constructor(
        public dialogRef: MatDialogRef<SmsCallRecordComponent>,
        private callRecordModuleService: CallRecordModuleService,
        private toastr: ToastrService,
        private translateService: TranslateService,
        @Inject(MAT_DIALOG_DATA)
        public data: { callRecordId: number; onStatusUpdate?: (callRecordId: number, newStatus: string) => void }
    ) {}

    ngOnInit() {
        this.getMessageDetails();
    }

    getMessageDetails() {
        this.showLoader = true;
        this.subs.sink = this.callRecordModuleService.getSmsCallDetails(this.data.callRecordId).subscribe({
            next: response => {
                this.smsCallRecordDetails = response;
                this.messageSplit = this.smsCallRecordDetails?.message;
                this.originalDeliveryStatus = this.getDeliveredMessagesCounter();
                this.showLoader = false;
            },
            error: () => {
                this.showLoader = false;
                this.toastr.error(this.translateService.instant('errorLoadingMessage'));
            }
        });
    }

    getDeliveredMessagesCounter() {
        if (this.smsCallRecordDetails?.recipients && this.smsCallRecordDetails.recipients.length > 0) {
            return this.smsCallRecordDetails.recipients.some(recipient => 
                recipient['notification-status'] === 'SUCCESSFUL'
            );
        }
        return false;
    }

    resendSms() {
        if (this.isRetrying) {
            return; // Prevent multiple clicks
        }

        // Reset previous retry states
        this.retrySuccess = false;
        this.retryError = false;
        this.isRetrying = true;
        
        this.subs.sink = this.callRecordModuleService.resendSmsNotification(this.data.callRecordId).subscribe({
            next: response => {
                this.isRetrying = false;
                this.retrySuccess = true;
                
                // Refresh the message details to get updated status
                this.refreshMessageStatus();
            },
            error: error => {
                this.isRetrying = false;
                this.retryError = true;
            }
        });
    }

    refreshMessageStatus() {
        // Refresh the message details to get the latest status
        this.subs.sink = this.callRecordModuleService.getSmsCallDetails(this.data.callRecordId).subscribe({
            next: response => {
                this.smsCallRecordDetails = response;
                
                // Check if delivery status changed from failed to success
                const newDeliveryStatus = this.getDeliveredMessagesCounter();
                if (!this.originalDeliveryStatus && newDeliveryStatus) {
                    // Status changed from failed to delivered - update the parent list
                    if (this.data.onStatusUpdate) {
                        this.data.onStatusUpdate(this.data.callRecordId, 'SUCCESSFUL');
                    }
                }
            },
            error: error => {
                // console.error('Error refreshing message status:', error);
            }
        });
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}